module.exports = __webpack_public_path__ + "media/images/shark/Shark3-a326bb89592f6d64c0fd11f0478a72a1.png";